/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Franchises_Meta_TitleInputs */

const id_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waralaba ${i?.name} | egdata.app`)
};

const ms_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Francais ${i?.name} | egdata.app`)
};

const da_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Franchise | egdata.app`)
};

const de_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Franchise | egdata.app`)
};

const en_us2_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Franchise | egdata.app`)
};

const es_es2_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franquicia ${i?.name} | egdata.app`)
};

const es_mx2_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franquicia ${i?.name} | egdata.app`)
};

const fil_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franquicia ${i?.name} | egdata.app`)
};

const fr_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franchise ${i?.name} | egdata.app`)
};

const it_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franchise ${i?.name} | egdata.app`)
};

const hu_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} franchise | egdata.app`)
};

const nl_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Franchise | egdata.app`)
};

const no_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-serien | egdata.app`)
};

const pl_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franczyza ${i?.name} | egdata.app`)
};

const pt_br2_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franquia ${i?.name} | egdata.app`)
};

const pt_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franquia ${i?.name} | egdata.app`)
};

const ro_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franciza ${i?.name} | egdata.app`)
};

const fi_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sarja ${i?.name} | egdata.app`)
};

const sv_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serien ${i?.name} | egdata.app`)
};

const vi_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thương hiệu ${i?.name} | egdata.app`)
};

const tr_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Serisi | egdata.app`)
};

const cs_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Franšíza ${i?.name} | egdata.app`)
};

const bg_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Франчайз ${i?.name} | egdata.app`)
};

const ru_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Франшиза: ${i?.name} | egdata.app`)
};

const uk_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Франшиза ${i?.name} | egdata.app`)
};

const ar_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سلسلة ${i?.name} | egdata.app`)
};

const hi_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} फ़्रैंचाइज़ी | egdata.app`)
};

const th_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แฟรนไชส์ ${i?.name} | egdata.app`)
};

const ja_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} フランチャイズ | egdata.app`)
};

const zh_cn2_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 系列 | egdata.app`)
};

const zh_hant1_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 系列 | egdata.app`)
};

const ko_franchises_meta_title = /** @type {(inputs: Franchises_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 프랜차이즈 | egdata.app`)
};

/**
* | output |
* | --- |
* | "{name} Franchise \| egdata.app" |
*
* @param {Franchises_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_meta_title = /** @type {((inputs: Franchises_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_meta_title(inputs)
	if (locale === "ms") return ms_franchises_meta_title(inputs)
	if (locale === "da") return da_franchises_meta_title(inputs)
	if (locale === "de") return de_franchises_meta_title(inputs)
	if (locale === "en-US") return en_us2_franchises_meta_title(inputs)
	if (locale === "es-ES") return es_es2_franchises_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_franchises_meta_title(inputs)
	if (locale === "fil") return fil_franchises_meta_title(inputs)
	if (locale === "fr") return fr_franchises_meta_title(inputs)
	if (locale === "it") return it_franchises_meta_title(inputs)
	if (locale === "hu") return hu_franchises_meta_title(inputs)
	if (locale === "nl") return nl_franchises_meta_title(inputs)
	if (locale === "no") return no_franchises_meta_title(inputs)
	if (locale === "pl") return pl_franchises_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_meta_title(inputs)
	if (locale === "pt") return pt_franchises_meta_title(inputs)
	if (locale === "ro") return ro_franchises_meta_title(inputs)
	if (locale === "fi") return fi_franchises_meta_title(inputs)
	if (locale === "sv") return sv_franchises_meta_title(inputs)
	if (locale === "vi") return vi_franchises_meta_title(inputs)
	if (locale === "tr") return tr_franchises_meta_title(inputs)
	if (locale === "cs") return cs_franchises_meta_title(inputs)
	if (locale === "bg") return bg_franchises_meta_title(inputs)
	if (locale === "ru") return ru_franchises_meta_title(inputs)
	if (locale === "uk") return uk_franchises_meta_title(inputs)
	if (locale === "ar") return ar_franchises_meta_title(inputs)
	if (locale === "hi") return hi_franchises_meta_title(inputs)
	if (locale === "th") return th_franchises_meta_title(inputs)
	if (locale === "ja") return ja_franchises_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_meta_title(inputs)
	return ko_franchises_meta_title(inputs)
});
export { franchises_meta_title as "franchises.meta.title" }